import { NameSuffix, nameSuffixDef } from "@inrev/common";
import { Control, FieldValues, Path } from "react-hook-form";
import { FormField, FormItemLabel, FormRow } from "../../form";
import { FormDropdown, FormInput } from "../../form/fields";

type ContactNameFieldValues = {
	firstName?: string | null;
	middleInitial?: string | null;
	lastName?: string | null;
	suffix?: NameSuffix | null;
};

type ContactNameFieldsProps<TFieldValues extends FieldValues & ContactNameFieldValues> = {
	control: Control<TFieldValues, any, any>;
	compact?: boolean;
};

const suffixOptions = nameSuffixDef.map((suffix) => ({ value: suffix, label: suffix }));

/**
 * The field names are cast to `Path<TFieldValues>`: the generic constraint guarantees the fields
 * exist, but TypeScript can't prove a string literal is a member of the recursive `Path` type for
 * an abstract generic. This bridges that limitation without widening the form type itself.
 */
export const ContactNameFields = <TFieldValues extends FieldValues & ContactNameFieldValues>({
	control,
	compact,
}: ContactNameFieldsProps<TFieldValues>) => (
	<FormRow>
		<FormField className="flex-2" condensed={compact}>
			<FormItemLabel condensed={compact} required>
				First Name
			</FormItemLabel>
			<FormInput name={"firstName" as Path<TFieldValues>} control={control} compact={compact} />
		</FormField>
		<FormField className="max-w-[80px]" condensed={compact}>
			<FormItemLabel condensed={compact}>MI</FormItemLabel>
			<FormInput
				name={"middleInitial" as Path<TFieldValues>}
				control={control}
				maxLength={1}
				onlyCharacters
				uppercase
				compact={compact}
			/>
		</FormField>
		<FormField className="flex-2" condensed={compact}>
			<FormItemLabel condensed={compact} required>
				Last Name
			</FormItemLabel>
			<FormInput name={"lastName" as Path<TFieldValues>} control={control} compact={compact} />
		</FormField>
		<FormField className="max-w-[100px]" condensed={compact}>
			<FormItemLabel condensed={compact}>Suffix</FormItemLabel>
			<FormDropdown
				name={"suffix" as Path<TFieldValues>}
				control={control}
				options={suffixOptions}
				deselectable
				compact={compact}
			/>
		</FormField>
	</FormRow>
);
